import React, { Component } from 'react';
import { Container, Col, Row, Modal, Button, Tabs, Tab, Nav, Badge } from 'react-bootstrap';
import apiRequests from './api-helpers/ApiRequests'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux'
import { FormattedInput } from "@buttercup/react-formatted-input";
import update from 'react-addons-update';
import Select from 'react-select';
import Scheduler from './Scheduler';
import ReactCountryFlag from "react-country-flag";
import CountryCodes from 'country-calling-code';
import PhoneNumber from 'libphonenumber-js';
import { useTranslation } from 'react-i18next';


class AddEventNotificationForm extends Component {

	constructor(props) {
		super(props);
		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
		formattedSelectedDay.setHours(12, 0, 0, 0);
		formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"
		this.defaultNotificationValue = {
			EventNotification: {
				EventDate: formattedSelectedDay,
				Target: "0",
				Nationality: "1",
				TransportsToAdd: [],
			},
			errors: "",
			isValidForm: true
		}
		this.state = {
			...this.defaultNotificationValue,
			NewItem: { Nationality: "1" },
			customOrder: ['PL', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'BY', 'UA', 'MD', 'TR', 'RS', 'BA', 'MK', 'ME', 'AL', 'XK', 'KZ', 'UZ', 'TM', 'KG', 'TJ', 'GE', 'AM', 'AZ', 'RU', 'NO', 'CH'],
			phoneNumber: '+48',
			customOrderItems: [],
			countriesList: [],
			selectedCountry: null,
			Contractors: [],
			Stuffs: [],
			Drivers: [],
			Cars: [],
			Semitrailers: [],
			EntranceWithoutSemi: false,
			ExitWithoutSemi: false,
			SelectedContractor: null,
			disableSubmitButton: true,
			privacyChecked: false,
			selectedOption: 'notify',
			activeStep: 1,
			showProductsList: "0X",
			brandsList: []
		}
		this.hideModal = this.hideModal.bind(this);
		this.onInputChange = this.onInputChange.bind(this);
		this.onFormSubmit = this.onFormSubmit.bind(this);
		this.newEventNotificationCallback = this.newEventNotificationCallback.bind(this);
		this.loadSelectControls = this.loadSelectControls.bind(this);
		// this.loadSelectProducts = this.loadSelectProducts.bind(this);
		this.loadSelectGroupBPSControlsCallback = this.loadSelectGroupBPSControlsCallback.bind(this);
		// this.loadSelectStuffsControlsCallback = this.loadSelectStuffsControlsCallback.bind(this);
		this.addNewItemRow = this.addNewItemRow.bind(this);
		this.deleteItemRow = this.deleteItemRow.bind(this);
		this.onListItemInputChange = this.onListItemInputChange.bind(this);
		this.loadSelectDriversControlsCallback = this.loadSelectDriversControlsCallback.bind(this);
		this.loadSelectCarsControlsCallback = this.loadSelectCarsControlsCallback.bind(this);
		this.onCustomSelectChange = this.onCustomSelectChange.bind(this);
		this.loadSelectSemitrailersControlsCallback = this.loadSelectSemitrailersControlsCallback.bind(this);
		this.loadSelectControls();
		this.handleChangeFormType = this.handleChangeFormType.bind(this);
	}

	componentDidUpdate(prevProps) {
		if ((prevProps.show !== this.props.show) && !prevProps.show) {
			this.addNewItemRow();
			let params =
			{
				DataInHttpResponse: true,
				SearchParams: [
					{ Name: "page", Value: "1" },
					{ Name: "size", Value: "10000000" },
					{ Name: "ExtCompanyId", Value: this.props.userData.CompanyWorkflowId + "X" },
				]
			};
			apiRequests.getDataByUrlWithParam('webconapi/GetContractorsItems', params, this.loadSelectGroupBPSControlsCallback);
		}
		if (prevProps.currentSelectedCalendarDay !== this.props.currentSelectedCalendarDay) {
			let formattedSelectedDay = this.props.currentSelectedCalendarDay;
			formattedSelectedDay.setHours(12, 0, 0, 0);
			formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"
			this.setState((prevState) => ({ EventNotification: { ...prevState.EventNotification, EventDate: formattedSelectedDay } }))
		}
	}


	// Hide Modal

	hideModal() {
		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
		formattedSelectedDay.setHours(12, 0, 0, 0);
		formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"

		this.defaultNotificationValue.EventNotification.EventDate = formattedSelectedDay;
		this.setState(
			{ ...this.defaultNotificationValue, disableSubmitButton: true, selectedOption: 'notify' }, 
			this.props.onChangeAddEventNotificationFormVisibilityHandler(false)
		);
	}
	////////////////////////////////////////////////
	//
	// Input & Select Change
	//
	////////////////////////////////////////////////
	onInputChange(event) {
		this.setState((prevState) => ({ EventNotification: { ...prevState.EventNotification, [event.target.name]: event.target.value } }), () => {
			if (!this.state.isValidForm) {
				apiRequests.getDataByUrlWithParam('webconapi/AddNewNotificationValidate', this.state.EventNotification, this.newEventNotificationCallback);
			}
		});
	}
	
	onCustomSelectChange(selectedOption, paramName) {
		this.setState(prevState => ({ EventNotification: { ...prevState.EventNotification, [paramName]: selectedOption.value } }), () => {
			//callback check data isValid on server side, after invalidate submit
			if (!this.state.isValidForm)
				apiRequests.getDataByUrlWithParam('webconapi/AddNewNotificationValidate', this.state.EventNotification, this.newEventNotificationCallback);
		});
		if( paramName == "GroupBPS" ){
			this.handleSetStuff( "" );
			let currentSelectedContractor = this.state.Contractors.find(c => c.value == selectedOption.value);
			this.setState((prevState) => ({
				showProductsList: currentSelectedContractor.Id
			}));
		}
		if( paramName != "Stuffs" ) {

			this.setState((prevState) => ({
				Stuffs: []
			}));
		}
	}

	onListItemInputChange(selectedOption, index, paramName) {
		this.setState(prevState => {
			const item = prevState.EventNotification.TransportsToAdd[index];
			const updatedItem = { ...item, [paramName]: selectedOption.value  }
			return { EventNotification: { ...prevState.EventNotification, TransportsToAdd: update(prevState.EventNotification.TransportsToAdd, { [index]: { $set: updatedItem } }) } };
		}, () => {
			//callback check data isValid on server side, after invalidate submit
			if (!this.state.isValidForm)
				apiRequests.getDataByUrlWithParam('webconapi/AddNewNotificationValidate', this.state.EventNotification, this.newEventNotificationCallback);
		});
	}

	////////////////////////////////////////////////
	//
	// Form Submit
	//
	////////////////////////////////////////////////
	onFormSubmit(event) {
		let eventNotification = this.state.EventNotification;
		this.setState({ 
			disableSubmitButton: this.state.isValidForm ? true : false,
			privacyChecked: this.state.isValidForm ? false : true,
		});
		// selectedOption: 'notify'
		if( this.state.selectedOption == 'notify' ) {
			eventNotification.SendedFormType = 'notify';
			eventNotification.IsSingle = "0";
			eventNotification.TransportsToAdd[0].IsSingle = "0";
		} 
		if( this.state.selectedOption == 'notify-single'  ) {
			eventNotification.SendedFormType = 'notify-single';
			eventNotification.IsSingle = "1";
			eventNotification.TransportsToAdd = [{
				Name: eventNotification.Name,
				Surname: eventNotification.Surname,
				Phone: eventNotification.Phone,
				Nationality: eventNotification.Nationality ? eventNotification.Nationality : '1',
				IdDocumentNumber: eventNotification.IdDocumentNumber,
				Address: eventNotification.Address,
				ZipCode: eventNotification.ZipCode,
				City: eventNotification.City,
				RegistationNumberOfCar: eventNotification.RegistationNumberOfCar,
				Mark: eventNotification.Mark,
				RegistationNumberOfTrailer: eventNotification.RegistationNumberOfTrailer,
				EntryTime: eventNotification.EventDate,
				IsSingle: "1"
			}];
		}
		if (eventNotification) {
			eventNotification.RequestClientId = this.props.signalRCurrentConnection.connectionId;
			eventNotification.CompanyWorkflowId = this.props.userData.CompanyWorkflowId + "";
			eventNotification.AccountWorkflowId = this.props.userData.AccountWorkflowId + "";
			apiRequests.getDataByUrlWithParam('webconapi/AddNewNotification', eventNotification, this.newEventNotificationCallback);
		}
		event.preventDefault();
	}

	newEventNotificationCallback(data, response) {
		if (response.status == 400) {
			if (data.errors) {
				this.setState({
					isValidForm: false,
					errors: data.errors,
					disableSubmitButton: true,
					privacyChecked: false
				});
			}
		}
		else if (response.status == 200) {
			if (data.Message && data.Message == "ok") {
				this.hideModal();
			}
			else {
				this.setState({
					errors: "",
					disableSubmitButton: false
				});
			}
		}
		this.props.addNewEventNotificationCallback(data);
	} 

	////////////////////////////////////////////////
	//
	// Load Controls
	//
	////////////////////////////////////////////////
	loadSelectControls() {
		let params =
		{
			DataInHttpResponse: true,
			SearchParams: [
				{ Name: "page", Value: "1" },
				{ Name: "size", Value: "10000000" },
				{ Name: "ExtCompanyId", Value: this.props.userData.CompanyWorkflowId + "X" },
				{ Name: "DId", Value: "0X" },
				// { Name: "ID_kontrahenci", Value: this.state.showProductsList ? this.state.showProductsList + "X" : "" }
			]
		};
		apiRequests.getDataByUrlWithParam('webconapi/GetContractorsItems', params, this.loadSelectGroupBPSControlsCallback);
		// apiRequests.getDataByUrlWithParam('webconapi/GetStuffsItems', params, this.loadSelectStuffsControlsCallback);
		apiRequests.getDataByUrlWithParam('webconapi/GetDriversDictionaryItems?fields=*', params, this.loadSelectDriversControlsCallback);
		apiRequests.getDataByUrlWithParam('webconapi/GetCarsDictionaryItems', params, this.loadSelectCarsControlsCallback);
		apiRequests.getDataByUrlWithParam('webconapi/GetSemitrailersItems', params, this.loadSelectSemitrailersControlsCallback);
	}

	loadSelectGroupBPSControlsCallback(Contractors) {
		this.setState((prevState) => ({
			Contractors 
		})); 
	}

	loadCarsList() {
		let params = {
			DataInHttpResponse: true,
			SearchParams: [],
			ReportID: "90", // Using report 90
		};

		apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, this.loadCarsListCallback.bind(this));
	}

	loadCarsListCallback(data) {
		if (data && data.rows && data.rows.length > 0) {
			const brands = data.rows.map(row => ({
				Name: row.cells[1].value
			}));

			this.setState({ brandsList: brands });
		}
	}

	loadSelectDriversControlsCallback(Drivers) {
		this.setState((prevState) => ({
			Drivers         
		})); 
	}

	loadSelectCarsControlsCallback(Cars) {
		this.setState((prevState) => ({
			Cars
		})); 
	}

	loadSelectSemitrailersControlsCallback(Semitrailers) {
		this.setState((prevState) => ({
			Semitrailers
		}));
	}

	////////////////////////////////////////////////
	//
	// Add & Delete Item Row
	//
	////////////////////////////////////////////////
	addNewItemRow() {
		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
		formattedSelectedDay.setHours(12, 0, 0, 0);
		formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"
		const newItem = {
			Driver: "",
			Car: "",
			Semitrailer: "", 
			EntryTime: formattedSelectedDay
		};
		this.setState(prevState => {
			return { EventNotification: { ...prevState.EventNotification, TransportsToAdd: [...prevState.EventNotification.TransportsToAdd, newItem] } };
		});
	}

	deleteItemRow(index) {
		this.setState(prevState => {
			return {
				EventNotification: {
					...prevState.EventNotification,
					TransportsToAdd: update(prevState.EventNotification.TransportsToAdd, { $splice: [[index, 1]] })
				}
			};
		}, () => {
			//callback check data isValid on server side, after invalidate submit
			if (!this.state.isValidForm)
				apiRequests.getDataByUrlWithParam('webconapi/AddNewNotificationValidate', this.state.EventNotification, this.newEventNotificationCallback);
		});
	}

	////////////////////////////////////////////////
	//
	// Privacy
	//
	////////////////////////////////////////////////
	privacyCheck = (event) => {
		this.setState({ 
			privacyChecked: !this.state.privacyChecked, 
			disableSubmitButton: !event.target.checked 
		});
	}

	////////////////////////////////////////////////
	//
	// Change Form Type
	//
	////////////////////////////////////////////////
	handleChangeFormType = (value) => {
		if( this.state.selectedOption == 'notify') {
			this.setState({ 
				selectedOption: value, 
				selectedCountry: null, 
				phoneNumber:  '+48', 
				activeStep: 1,
			});
		} else {
			this.setState({ selectedOption: value, activeStep: 1 });
		}
		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
		formattedSelectedDay.setHours(12, 0, 0, 0);
		formattedSelectedDay = formattedSelectedDay.toISOString().substring(0, 10) + "T00:00"
		this.setState({ 
			EventNotification: {
				EventDate: formattedSelectedDay,
				Target: "0",
				TransportsToAdd: [],
			},
			errors: "",
			isValidForm: true
		});
		this.deleteItemRow();
		this.addNewItemRow();
	}

	handleChangeStep = (index) => {
		if( index !== this.state.activeStep && index < 5 && index > 0 ) {
			this.setState( { activeStep: index });
		}
	};

	////////////////////////////////////////////////
	//
	// Phone Field
	//
	////////////////////////////////////////////////
	componentDidMount() {
		const { customOrder } = this.state;
		const customOrderItems = [];
		this.loadCarsList();
		const countriesList = Object.keys(CountryCodes)
			.map((countryCode, index) => {
				const countryData = CountryCodes[countryCode];		
				if (customOrder.includes(countryData.isoCode2)) {
					if (countryData.isoCode2 == customOrder[0]) {
						this.setState({ phoneNumber: `+${countryData.countryCodes[0]}` });
					}
					const customOrderItem = {
						code: countryData.isoCode2,
						label: (
							<span>
								<ReactCountryFlag countryCode={countryData.isoCode2} svg /> {countryData.country}
							</span>
						),
						value: `+${countryData.countryCodes[0]}`,
					};
					customOrderItems.push(customOrderItem);
				}
				return {
					code: countryData.isoCode2,
					label: (
						<span>
							<ReactCountryFlag countryCode={countryData.isoCode2} svg /> {countryData.country}
						</span>
					),
					value: `+${countryData.countryCodes[0]}`,
				};
			})
			.filter((country) => !customOrder.includes(country.code));
		// Reorder customOrderItems based on customOrder array
		const reorderedCustomOrderItems = customOrder.map((code) =>
			customOrderItems.find((item) => item.code === code)
		);
		this.setState({
			customOrderItems: reorderedCustomOrderItems,
			EntranceWithoutSemi: false,
			ExitWithoutSemi: false,
			countriesList,
		});
	}

	handlePhoneTextChange = (event) => {
		const selCountryVal = this.state.selectedCountry ? this.state.selectedCountry : null;
		const { value } = event.target;
		this.setState({ phoneNumber: selCountryVal && value.length <= selCountryVal.value.length ? (`${selCountryVal.value }`) : value });
		this.onInputChange(event);
	};

	handleCountryChange = (selectedCountry) => {
		this.setState({ phoneNumber: '' });
		this.setState({ selectedCountry }, () => {
			const { selectedCountry, phoneNumber } = this.state;
			if (selectedCountry) {
				const countryCode = selectedCountry.value;
				this.setState({ phoneNumber: `${countryCode}${phoneNumber}` }, () => {});
			}
		});
	};

	handleSetStuff = (SelectedStuff) => {
		this.onCustomSelectChange(SelectedStuff, "Stuff");
	};
	handleSetTrailerEntrance = (checked, type) => {
		if (type === 'EntranceWithoutSemi') {
			this.setState({ EntranceWithoutSemi: checked, ExitWithoutSemi: false });
			this.onCustomSelectChange({ value: checked }, `EntranceWithoutSemi`);
			this.onCustomSelectChange({ value: false }, `ExitWithoutSemi`);
		} else if (type === 'ExitWithoutSemi') {
			this.setState({ ExitWithoutSemi: checked, EntranceWithoutSemi: false })
			this.onCustomSelectChange({ value: checked }, `ExitWithoutSemi`);
			this.onCustomSelectChange({ value: false }, `EntranceWithoutSemi`);
		}
	
	}

	render() {
		let formattedSelectedDay = this.props.currentSelectedCalendarDay;
	    formattedSelectedDay.setHours(12, 0, 0, 0);
	    let formattedSelectedDayOnlyDate = formattedSelectedDay.toISOString().substring(0, 10)
	    formattedSelectedDay = formattedSelectedDayOnlyDate + "T00:00"
	    let formattedSelectedDayMin = formattedSelectedDayOnlyDate + "T00:00"
	    let formattedSelectedDayMax = formattedSelectedDayOnlyDate + "T23:59"
	    let currentSelectedContractor = this.state.Contractors.find(c => c.value == this.state.EventNotification.GroupBPS)
		const { phoneNumber, customOrderItems, activeStep } = this.state;
		const a = this.state.NewItem.Nationality == "1";
		const ZipCodePattern = [
			{ char: /\d/, repeat: 2 },
			{ exactly: "-" },
			{ char: /\d/, repeat: 3 },
		];
		const formData = this.state.selectedOption == 'notify' ? (
			<form id="new-ev-not-form" onSubmit={this.onFormSubmit}>
				<Container className="ps-0 pe-0 me-2" fluid>
					<Row>
						<Col lg={6} sm={5} className="col form-font">
							<div className="field">
								<label htmlFor="dt1" className="form-label m-0 p-0">{this.props.t('notification.notify.dateLabel')}</label>
								<input type="date" className="form-control" id="dt1" name="EventDate" onChange={this.onInputChange} defaultValue={formattedSelectedDayOnlyDate} readOnly disabled />
							</div>
							<div className="field">
								<label 
									htmlFor="transportSignature" 
									className="form-label m-0 p-0"
								>
									<sup className="text-danger"></sup>
									{this.props.t('notification.notify.signatureLabel')}
								</label>
								<input 
									type="text" 
									className="form-control" 
									id="transportSignature" 
									name="TransportSignature" 
									onChange={this.onInputChange} 
								/>
								<span 
									className="text-danger"
								>
									{ this.state.errors.TransportSignature ? this.state.errors.TransportSignature[0] : "" }
								</span>
							</div>
							<div className="field">
								<label htmlFor="target" className="form-label m-0 p-0">{this.props.t('notification.notify.targetLabel')}</label>
								<select defaultValue="" className="form-select m-0" name="Target" id="target" aria-label={this.props.t('common.select')} onChange={this.onInputChange}>
									<option value="0" selected>{this.props.t('notification.notify.targetPickup')}</option>
									<option value="1">{this.props.t('notification.notify.targetWithGoods')}</option>
								</select>
							</div>
							{ this.state.EventNotification.TransportsToAdd.map((item, index) => (
								<div key={index}>
									<div className="field d-none">
										<label className="form-label p-0 m-0 mt-1"><sup className="text-danger">*</sup>{this.props.t('notification.notify.entryTimeLabel')}</label>
										<input 
											type="datetime-local" 
											className="form-control m-0" 
											id={"et" + index} 
											name="EntryTime" 
											onChange={(event) => this.onListItemInputChange({ value: event.target.value }, index, "EntryTime")} 
											defaultValue={formattedSelectedDay} 
											min={formattedSelectedDayMin} 
											max={formattedSelectedDayMax} 
										/>
									</div>
									<div className="field">
										<label className="form-label p-0 m-0 mt-1"><sup className="text-danger">*</sup>{this.props.t('notification.notify.driverLabel')}</label>
										<Select 
											className="form-control m-0 border-0 p-0" 
											placeholder={this.props.t('common.select')}
											noOptionsMessage={() => ("Nie znaleziono wartości")}
											value={
												this.state.Drivers.find(d => d.value == item.Driver)
											}
											options={this.state.Drivers.map(driver => (
												{
													value: driver.value,
													label: driver.label + ` - ` + driver.doc
												}
											))}
											onChange={(selectedOption) => this.onListItemInputChange(selectedOption, index, "Driver")}
										/>
										<span className="text-danger">{this.state.errors["TransportsToAdd[0].Driver"] ? this.state.errors["TransportsToAdd[0].Driver"]  : ""}</span>
									</div>
									<div className="field">
										<label className="form-label p-0 m-0 mt-1"><sup className="text-danger">*</sup>{this.props.t('notification.notify.carLabel')}</label>
										<Select className="form-control m-0 border-0 p-0" placeholder={this.props.t('common.select')} noOptionsMessage={() => ("Nie znaleziono wartości")}
											 value={this.state.Cars.find(c => c.value == item.Car)}
											 options={this.state.Cars}
											 onChange={(selectedOption) => this.onListItemInputChange(selectedOption, index, "Car")}
										/>
										<span className="text-danger">{this.state.errors["TransportsToAdd[0].Car"] ? this.state.errors["TransportsToAdd[0].Car"] : ""}</span>
									</div>
									<div className="field">
										<label className="form-label p-0 m-0 mt-1"><sup className="text-danger">*</sup>{this.props.t('notification.notify.trailerLabel')}</label>
										<Select className="form-control m-0 border-0 p-0" placeholder={this.props.t('common.select')} noOptionsMessage={() => ("Nie znaleziono wartości")}
											value={this.state.Semitrailers.find(s => s.value == item.Semitrailer)}
											options={this.state.Semitrailers}
											onChange={(selectedOption) => this.onListItemInputChange(selectedOption, index, "Semitrailer")}
										/>
										<span className="text-danger">{this.state.errors["TransportsToAdd[0].Semitrailer"] ? this.state.errors["TransportsToAdd[0].Semitrailer"] : ""}</span>
									</div>
								</div>
							))}
						</Col>
						<Col lg={6} sm={5} className="col form-font">
							<div className="field">
								<label htmlFor="groupBPS" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notify.contractorLabel')}</label>
								<Select className="form-control m-0 border-0 p-0" placeholder={this.props.t('common.select')}
									value={this.state.Contractors.find(d => d.value == this.state.EventNotification.GroupBPS)}
									options={this.state.Contractors}
									onChange={(selectedOption) => {
										this.onCustomSelectChange(selectedOption, "GroupBPS");
										this.onCustomSelectChange({ value: selectedOption.Gate.id }, "Gate");
									}}
								/>
								<span className="text-danger">{this.state.errors.GroupBPS ? this.state.errors.GroupBPS[0] : ""}</span>
							</div>
							<Scheduler
								currenSelectedDate={formattedSelectedDayOnlyDate}
								onCustomSelectChange={this.onCustomSelectChange}
								EntryStartTimeErrors={this.state.errors.EntryStartTime  ? this.state.errors.EntryStartTime[0] : ""}
								StuffErrors={this.state.errors.Stuff ? this.state.errors.Stuff[0] : ""}
								Contractor={currentSelectedContractor}
								setStuff={ this.handleSetStuff }
								EventNotification={ this.state.EventNotification }
							/>
						</Col>
					</Row>
				</Container>
			</form>
		) : (
			<form id="new-ev-not-form" className="add-notifications-form" onSubmit={this.onFormSubmit}>
				<Tab.Container activeKey={ this.state.activeStep } >
					<Row>
						<Col sm={3} className={ "side-steps" }>
							<Nav variant="pills" className="flex-column">
								<Nav.Item>
									<Nav.Link eventKey="1" onClick={ () => this.handleChangeStep( 1 ) }>
										<Badge bg={
											"primary"
										}>
												{this.props.t('notification.common.step')} 1.
										</Badge> 
											<span className="ps-2">{this.props.t('notification.common.step1')}</span>
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="2" onClick={ () => this.handleChangeStep( 2 ) }>
										<Badge bg={
											this.state.errors["TransportsToAdd[0].Name"] || 
											this.state.errors["TransportsToAdd[0].Surname"] || 
											this.state.errors["TransportsToAdd[0].IdDocumentNumber"] ||
											this.state.errors["TransportsToAdd[0].Phone"] ? "danger" : "primary"
										}>
												{this.props.t('notification.common.step')} 2.
										</Badge>
											<span className="ps-2">{this.props.t('notification.common.step2')}</span>
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="3" onClick={ () => this.handleChangeStep( 3 ) }>
										<Badge bg={
											this.state.errors["TransportsToAdd[0].RegistationNumberOfCar"] ||
											this.state.errors["TransportsToAdd[0].RegistationNumberOfTrailer"] ? "danger" : "primary"
										}>
												{this.props.t('notification.common.step')} 3.
										</Badge> 
											<span className="ps-2">{this.props.t('notification.common.step3')}</span>
									</Nav.Link>
								</Nav.Item>
								<Nav.Item>
									<Nav.Link eventKey="4" onClick={ () => this.handleChangeStep( 4 ) }>
										<Badge bg={
											this.state.errors.GroupBPS ||
											this.state.errors.EntryStartTime ? "danger" : "primary"
										}>
												{this.props.t('notification.common.step')} 4.
										</Badge> 
											<span className="ps-2">{this.props.t('notification.common.step4')}</span>
									</Nav.Link>
								</Nav.Item>
							</Nav>
						</Col>
						<Col sm={9}>
							<Tab.Content>
								<Tab.Pane eventKey="1">
									<div className="field">
											<label htmlFor="dt1" className="form-label">{this.props.t('notification.notify.dateLabel')}</label>
										<input type="date" className="form-control" id="dt1" name="EventDate" onChange={this.onInputChange} defaultValue={formattedSelectedDayOnlyDate} readOnly disabled/>
									</div>
									<div className="field">
											<label htmlFor="transportSignature" className="form-label"><sup className="text-danger"></sup>{this.props.t('notification.notify.signatureLabel')}</label>
										<input type="text" className="form-control" id="transportSignature" name="TransportSignature" onChange={this.onInputChange} />
										<span className="text-danger">{this.state.errors.TransportSignature ? this.state.errors.TransportSignature[0] : ""}</span>
									</div>
									<div className="field">
											<label htmlFor="target" className="form-label">{this.props.t('notification.notify.targetLabel')}</label>
											<select defaultValue="" className="form-select" name="Target" id="target" aria-label={this.props.t('common.select')} onChange={this.onInputChange}>
												<option value="0" selected>{this.props.t('notification.notify.targetPickup')}</option>
												<option value="1">{this.props.t('notification.notify.targetWithGoods')}</option>
										</select>
									</div>
									<div className="notification-form-btns">
										<Button type="button" variant="outline-secondary" onClick={ () => this.handleChangeStep( this.state.activeStep + 1 ) }>
												{this.props.t('common.next')}
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
											</svg>
										</Button>
									</div>
								</Tab.Pane>
								<Tab.Pane eventKey="2">
									{ this.state.EventNotification.TransportsToAdd.map((item, index) => (
										<div key={index}>
											<div className="field d-none">
												<label className="form-label p-0 m-0 mt-1"><sup className="text-danger">*</sup>{this.props.t('notification.notify.entryTimeLabel')}</label>
												<input type="datetime-local" className="form-control m-0" id={"et" + index} name="EntryTime" onChange={(event) => this.onListItemInputChange({ value: event.target.value }, index, "EntryTime")} defaultValue={formattedSelectedDay} min={formattedSelectedDayMin} max={formattedSelectedDayMax} />
											</div>
											<div className="field">
												<label htmlFor="name" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.nameLabel')}</label>
												<input 
													type="text" 
													className="form-control" 
													defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[1].value : '' } 
													id="name" 
													name="Name" 
													onChange={this.onInputChange}
													readOnly={ this.props.formEvent == "editDriver" ? true : false }
												/>
												<span className="text-danger">{this.state.errors["TransportsToAdd[0].Name"] ? this.state.errors["TransportsToAdd[0].Name"][0] : ""}</span>
											</div>
											<div className="field">
												<label htmlFor="surname" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.surnameLabel')}</label>
												<input 
													type="text" 
													className="form-control" 
													id="surname" 
													name="Surname" 
													onChange={this.onInputChange} 
													defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[2].value : '' } 
													readOnly={ this.props.formEvent == "editDriver" ? true : false }
												/>
												<span className="text-danger">{this.state.errors["TransportsToAdd[0].Surname"] ? this.state.errors["TransportsToAdd[0].Surname"][0] : ""}</span>
											</div>
											<div className="field">
												<label htmlFor="nationality" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.nationalityLabel')}</label>
												<select 
													className="form-select" 
													name="Nationality" 
													id="nationality"
													aria-label={this.props.t('common.select')}
													defaultValue=""
													onChange={this.onInputChange} 
												>
													<option 
														value="1" 
														selected={true}
													>
														{this.props.t('notification.notifySingle.nationalityPl')}
													</option>
													<option 
														value="2"
													>
														{this.props.t('notification.notifySingle.nationalityForeign')}
													</option>
												</select>
												<span className="text-danger">{this.state.errors.Nationality ? this.state.errors.Nationality[0] : ""}</span>
											</div>
											<div className={"field " + (this.state.NewItem.Nationality == "1" ? "" : "")}>
												<label htmlFor="idDocumentNumber" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.documentLabel')}</label>
												<input 
													type="text" 
													className="form-control" 
													id="idDocumentNumber" 
													name="IdDocumentNumber" 
													onChange={this.onInputChange} 
													defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[4].value : '' } 
													readOnly={ this.props.formEvent == "editDriver" ? true : false }
												/>
												<span className="text-danger">{this.state.errors["TransportsToAdd[0].IdDocumentNumber"] ? this.state.errors["TransportsToAdd[0].IdDocumentNumber"][0] : ""}</span>
											</div>
											<div className="field">
												<label htmlFor="address" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.addressLabel')}</label>
												<input 
													type="text" 
													className="form-control" 
													id="address" 
													name="Address" 
													onChange={this.onInputChange}
													defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[5].value : '' } 
													placeholder={this.props.t('notification.notifySingle.addressPlaceholder')}
													readOnly={ this.props.formEvent == "editDriver" ? true : false }
												/>
												<span className="text-danger">{this.state.errors.Address ? this.state.errors.Address[0] : ""}</span>
											</div>
											<div className="field">
												<label htmlFor="zipCode" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.zipLabel')}</label>
												<FormattedInput
													id="zipCode"
													name="ZipCode"
													className="form-control"
													format={ZipCodePattern}
													onChange={(formattedValue, raw) => {
														const event =
														{
															target: {
																value: formattedValue,
																name: "ZipCode"
															}
														}
														this.onInputChange(event)
													}}
													defaultValue={ '' } 
													placeholder="np. 12-345"
												/>
												<span className="text-danger">{this.state.errors.ZipCode ? this.state.errors.ZipCode[0] : ""}</span>
											</div>
											<div className="field">
												<label htmlFor="city" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.cityLabel')}</label>
												<input 
													type="text" 
													className="form-control" 
													id="city" 
													name="City" 
													onChange={this.onInputChange} 
													defaultValue={ this.props.formEvent == "editDriver" && this.props.selectedItem.cells ? this.props.selectedItem.cells[7].value : '' } 
													readOnly={ this.props.formEvent == "editDriver" ? true : false }
												/>
												<span className="text-danger">{this.state.errors.City ? this.state.errors.City[0] : ""}</span>
											</div>
											<div className="field">
												<label htmlFor="phone" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.phoneLabel')}</label>
												<div className="input-group phone-input-group">
													<Select
														options={customOrderItems}
														defaultValue={customOrderItems[0]}
														onChange={this.handleCountryChange}
														placeholder="Select a country"
														isSearchable={false}
													/>
													<input
														type="tel"
														pattern="\+\d*"
														className="form-control"
														id="phone"
														name="Phone"
														value={phoneNumber}
														onChange={this.handlePhoneTextChange}
													/>
												</div>
												<span className="text-danger">{this.state.errors["TransportsToAdd[0].Phone"] ? this.state.errors["TransportsToAdd[0].Phone"][0] : ""}</span>
												{ this.props.formEvent == "addDriver" ? (
													<span className="text-danger lh-6">{this.props.t('notification.notifySingle.phoneNote')}</span>
													) : '' }
											</div>
										</div>
									))}
									<div className="d-flex flex-row gap-2 notification-form-btns">
										<Button type="button" variant="outline-secondary" onClick={ () => this.handleChangeStep( this.state.activeStep - 1 ) }>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
											</svg>
												{this.props.t('common.previous')}
										</Button>
										<Button type="button" variant="outline-secondary" onClick={ () => this.handleChangeStep( this.state.activeStep + 1 ) }>
											{this.props.t('common.next')}
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
											</svg>
										</Button>
									</div>
								</Tab.Pane>
								<Tab.Pane eventKey="3">
									<div className="field">
											<label htmlFor="mark" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.vehicleBrandLabel')}</label>
											<select className="form-control" id="mark" name="Mark" onChange={this.onInputChange} required>
												<option value="">{this.props.t('cars.modal.validationBrand')}</option>
												{this.state.brandsList.map((brand, index) => (
													<option key={index} value={brand.Name}>
														{brand.Name}
													</option>
												))}
											</select>

										<span className="text-danger">{this.state.errors["TransportsToAdd[0].Mark"] ? this.state.errors["TransportsToAdd[0].Mark"][0] : ""}</span>
										</div>
									<div className="field">
											<label htmlFor="registationNumber" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.vehiclePlateLabel')}</label>
										<input type="text" className="form-control" id="registationNumberOfCar" name="RegistationNumberOfCar" onChange={this.onInputChange} />
										<span className="text-danger">{this.state.errors["TransportsToAdd[0].RegistationNumberOfCar"] ? this.state.errors["TransportsToAdd[0].RegistationNumberOfCar"][0] : ""}</span>
									</div>
									<div className="field">
											<label htmlFor="registationNumber" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notifySingle.trailerPlateLabel')}</label>
									    <input type="text" className="form-control" id="registationNumberOfTrailer" name="RegistationNumberOfTrailer" onChange={this.onInputChange} />
									    <span className="text-danger">{this.state.errors["TransportsToAdd[0].RegistationNumberOfTrailer"] ? this.state.errors["TransportsToAdd[0].RegistationNumberOfTrailer"][0] : ""}</span>
									</div>
									<div className="field d-none">
											<label htmlFor="semitrailerType" className="form-label m-0 p-0">{this.props.t('notification.notifySingle.trailerTypeLabel')}</label>
									    <input type="text" className="form-control" id="semitrailerType" name="SemitrailerType" onChange={this.onInputChange} />
									    <span className="text-danger">{this.state.errors.SemitrailerType ? this.state.errors.SemitrailerType[0] : ""}</span>
									</div>
									<div className="notification-form-btns">
										<Button type="button" variant="outline-secondary" onClick={ () => this.handleChangeStep( this.state.activeStep - 1 ) }>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
											</svg>
												{this.props.t('common.next')}
										</Button>
										<Button type="button" variant="outline-secondary" onClick={ () => this.handleChangeStep( this.state.activeStep + 1 ) }>
											{this.props.t('common.previous')}
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/>
											</svg>
										</Button>
									</div>
								</Tab.Pane>
								<Tab.Pane eventKey="4">
									<div className="field">
											<label htmlFor="groupBPS" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('notification.notify.contractorLabel')}</label>
											<Select className="form-control m-0 border-0 p-0" placeholder={this.props.t('common.select')}
											value={this.state.Contractors.find(d => d.value == this.state.EventNotification.GroupBPS)}
											options={this.state.Contractors}
											onChange={(selectedOption) => {
												this.onCustomSelectChange(selectedOption, "GroupBPS");
												this.onCustomSelectChange({ value: selectedOption.Gate.id }, "Gate");
											}}
										/>
										<span className="text-danger">{this.state.errors.GroupBPS ? this.state.errors.GroupBPS[0] : ""}</span>
									</div>
									<Scheduler
										currenSelectedDate={formattedSelectedDayOnlyDate}
										onCustomSelectChange={this.onCustomSelectChange}
										errors={this.state.errors.EntryStartTime ? this.state.errors.EntryStartTime[0] : ""}
										Contractor={currentSelectedContractor}
										setStuff={ this.handleSetStuff }
										EventNotification={ this.state.EventNotification }
									/>
									<div className="notification-form-btns">
										<Button type="button" variant="outline-secondary" onClick={ () => this.handleChangeStep( this.state.activeStep - 1 ) }>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
												<path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/>
											</svg>
												{this.props.t('common.previous')}
										</Button>
									</div>
								</Tab.Pane>
							</Tab.Content>
						</Col>
					</Row>
				</Tab.Container>
			</form>
		); 
		return (			
			<>
				<Modal  
					dialogClassName="modal-large-size addNotificationModal" 
					show={this.props.show} 
					onHide={this.hideModal}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<Tab.Container defaultActiveKey="notify">
								<Nav 
									variant="pills" 
									className="flex-row gap-2" 
									onSelect={ this.handleChangeFormType }
								>
									<Nav.Item>
										<Nav.Link eventKey="notify" className="fs-6"><Badge bg="primary">1</Badge> {this.props.t('notification.modalTitleNotify')}</Nav.Link>
									</Nav.Item>
									<Nav.Item>
										<Nav.Link eventKey="notify-single" className="fs-6"><Badge bg="primary">2</Badge> {this.props.t('notification.modalTitleNotifySingle')}</Nav.Link>
									</Nav.Item>
								</Nav>
							</Tab.Container>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{ formData }
					</Modal.Body>
					<Modal.Footer>
						<div className="form-check">
							<input className="form-check-input" type="checkbox" required checked={ this.state.privacyChecked } onChange={ this.privacyCheck } />
							<label className="form-check-label" htmlFor="flexCheckDefault">
								<sup className="text-danger">*</sup>{this.props.t('notification.common.privacyCheckbox')} <a data-toggle="modal" target="_blank" href="https://awizacje.portgdansk.pl/pdf/Regulamin_SARP.pdf">{this.props.t('notification.common.regulationsLink')} </a> {this.props.t('notification.common.privacy2')} <a data-toggle="modal" target="_blank" href="https://www.portgdansk.pl/polityka-prywatnosci/">{this.props.t('notification.common.privacyPolicyLink')}</a> {this.props.t('notification.common.privacy3')} Zarząd Morskiego Portu Gdańsk S.A.
							</label>
						</div>	
						<div className="btns-group">
							<button form="new-ev-not-form" type="submit" className={"btn btn-primary mr-2"} disabled={ this.state.disableSubmitButton }>
								{this.props.t('common.submit')}
							</button>
							<Button variant="secondary" onClick={this.hideModal} >
								{this.props.t('common.close')}
							</Button>
						</div>
					</Modal.Footer>
				</Modal>
			</>
		);
	}
}

function withMyHook(Component) { 
	return function WrappedComponent(props) {
		const signalRCurrentConnection = useSelector((state) => state.signalRCurrentConnection.connection);
		const { t } = useTranslation();

		return <Component {...props} signalRCurrentConnection={signalRCurrentConnection} t={ t } />;
	}
}

export default withMyHook(AddEventNotificationForm)